// 组件对象，大写
// import iconSelect from './iconSelect.vue'
import { PgDialogSelectIcon } from 'pangu-components-plus'
export default PgDialogSelectIcon
